import { colors } from "../../utils/utils";

const Badge = ({ type, text, textColor, bgColor }) => {
    const selectedColors = colors[type] || {
        textColor: textColor || "#364153",
        bgColor: bgColor || "#F3F4F6",
    };

    if (!text) return null;

    return (
        <span
            className="text-xs font-medium text-center px-3 py-1 rounded-full uppercase"
            style={{
                color: selectedColors.textColor,
                backgroundColor: selectedColors.bgColor,
            }}
        >
            {text}
        </span>
    );
};

export default Badge;